const timeoutPromise = (p, timeout) =>
  Promise.race([p, new Promise((resolve, reject) => setTimeout(reject, timeout))]);

export default timeoutPromise;



// WEBPACK FOOTER //
// ../utils/functions/timeout-promise.js